import React from 'react'

import {
  TableHead,
  TableCell,
  TableRow,
  withStyles,
  useTheme,
  Grid,
  Typography
} from '@material-ui/core'

const Head = ({ percentError, translate }) => {
  const theme = useTheme()
  const headBackgroundColor = theme.palette.tableHead ?? '#3d6bb3'

  const percentBudgetText = translate('percentBudget')
  const percentBudgetError = translate('sumIsNot100')
  const percentBudgetDisplay = percentError ? (
    <Grid container direction={'column'}>
      <Grid item>{percentBudgetText}</Grid>
      <Grid item>
        <Typography variant={'caption'} color={'error'}>
          {percentBudgetError}
        </Typography>
      </Grid>
    </Grid>
  ) : (
    percentBudgetText
  )
  return (
    <TableHead>
      <TableRow>
        <TableHeadCell
          rowSpan={2}
          align={'center'}
          style={{
            borderRightWidth: 1,
            borderRightStyle: 'solid',
            borderRightColor: theme.palette.getContrastText(headBackgroundColor)
          }}>
          {translate('grade')}
        </TableHeadCell>
        <TableHeadCell colSpan={5} align={'center'}>
          {translate('gradeCondition')}
        </TableHeadCell>
      </TableRow>
      <TableRow>
        <TableHeadCell align={'center'}>{translate('beginScore')}</TableHeadCell>
        <TableHeadCell align={'center'}>{translate('endScore')}</TableHeadCell>
        <TableHeadCell align={'center'}>{translate('salaryRaise')}</TableHeadCell>
        <TableHeadCell align={'center'}>{percentBudgetDisplay}</TableHeadCell>
        <TableHeadCell align={'center'}>{translate('bonusMonth')}</TableHeadCell>
      </TableRow>
    </TableHead>
  )
}

const TableHeadCell = withStyles(theme => {
  const headBackgroundColor = theme.palette.tableHead ?? '#3d6bb3'
  return {
    root: {
      backgroundColor: headBackgroundColor,
      color: theme.palette.getContrastText(headBackgroundColor)
    }
  }
})(TableCell)

export default Head
